import {createAction} from '@reduxjs/toolkit';
import {
    apiCallPrepareActionBuilder,
    apiErrorPrepareAction,
    apiResponsePrepareAction,
} from 'modules/api/actions';
import {apiEndpoints} from 'modules/api/constants';
import slice from './slice';

export const submitUsername = createAction('submitUsername');
export const cancelLogin = createAction('cancelLogin');
export const submitPassword = createAction('submitPassword');
export const submitForgottenPasswordEmail = createAction('submitForgottenPasswordEmail');
export const submitForgottenPasswordCode = createAction('submitForgottenPasswordCode');
export const submitNewPassword = createAction(
    'submitNewPassword',
    (password, confirm) => ({
        payload: {
            password,
            confirm,
        },
    })
);
export const cancelPasswordReset = createAction('cancelPasswordReset');
export const completePasswordReset = createAction('completePasswordReset');
export const exitPasswordReset = createAction('completePasswordReset');
export const logOut = createAction('logOut');
export const sessionTimeout = createAction('sessionTimeout');

export const authenticationInProgress = createAction('authenticationInProgress');
export const receiveAuthenticationMethod = createAction('receiveAuthenticationMethod', apiResponsePrepareAction);
export const receiveAuthenticationToken = createAction('receiveAuthenticationToken', apiResponsePrepareAction);
export const getNewApplicationToken = createAction('getNewApplicationToken');
export const receiveApplicationToken = createAction('receiveAuthenticationToken', apiResponsePrepareAction);
export const applicationTokenSet = createAction('applicationTokenSet');
export const applicationTokenError = createAction('applicationTokenError');
export const authenticationError = createAction('authenticationError', apiErrorPrepareAction);
export const logoutInProgress = createAction('logoutInProgress');
export const logoutError = createAction('logoutError');
export const validateResetCodeSuccess = createAction('validateResetCodeSuccess', apiResponsePrepareAction);
export const passwordResetCodeSuccess = createAction('passwordResetCodeSuccess', apiResponsePrepareAction);
export const passwordResetInProgress = createAction('passwordResetInProgress');
export const cancelPasswordRequest = createAction('cancelPasswordRequest');
export const passwordResetSuccess = createAction('passwordResetSuccess');
export const passwordResetCancelled = createAction('passwordResetCancelled');
export const passwordResetError = createAction('passwordResetError', apiErrorPrepareAction);

export const getAuthMethodForUser = createAction(
    'checkUsernameApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.AUTHENTICATION_METHOD,
        'get',
        authenticationInProgress,
        receiveAuthenticationMethod,
        authenticationError,
    )
);

export const authenticateUser = createAction(
    'authenticateUserApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.AUTHENTICATE,
        'post',
        authenticationInProgress,
        receiveAuthenticationToken,
        authenticationError,
    )
);

export const exchangeToken = createAction(
    'exchangeTokenApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.EXCHANGE_TOKEN,
        'post',
        authenticationInProgress,
        receiveAuthenticationToken,
        authenticationError,
    )
);

export const invalidateToken = createAction(
    'invalidateTokenApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.LOGOUT,
        'get',
        logoutInProgress,
        null,
        logoutError,
        null,
        true
    )
);

export const newAccessToken = createAction(
    'newAccessToken',
    apiCallPrepareActionBuilder(
        apiEndpoints.NEW_ACCESS_TOKEN,
        'get',
        authenticationInProgress,
        receiveApplicationToken,
        authenticationError,
    )
)

export const refreshAccessToken = createAction(
    'refreshAccessToken',
    apiCallPrepareActionBuilder(
        apiEndpoints.REFRESH_ACCESS_TOKEN,
        'get',
        authenticationInProgress,
        receiveApplicationToken,
        authenticationError,
    )
)

// Request a password reset code
export const requestPasswordResetCode = createAction(
    'requestPasswordResetApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.PASSWORD_CODE_GENERATE,
        'post',
        passwordResetInProgress,
        passwordResetCodeSuccess,
        passwordResetError,
    )
);

export const validatePasswordResetCode = createAction(
    'validatePasswordResetCodeApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.PASSWORD_CODE_VERIFY,
        'post',
        passwordResetInProgress,
        validateResetCodeSuccess,
        passwordResetError,
    )
);

export const changePasswordForUser = createAction(
    'changePasswordForUserApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.PASSWORD_CHANGE,
        'post',
        passwordResetInProgress,
        passwordResetSuccess,
        passwordResetError,
    )
);

export const cancelPasswordChange = createAction(
    'cancelPasswordChangeApiCall',
    apiCallPrepareActionBuilder(
        apiEndpoints.PASSWORD_CANCEL_CHANGE,
        'post',
        cancelPasswordRequest,
        passwordResetCancelled,
        passwordResetError,
    )
);

export const {setLoginState, setPasswordResetState, setInvalidResetCode, incrementFailedLoginAttempts, resetFailedLoginAttempts} = slice.actions;